import { useSimpleDataList } from "../hooks/useDataList";
import { paginatedAutomationDetailsActions, paginatedAutomationDetailsSelector } from "../redux/slicers/automation/paginatedAutomationDetails";
import { getAutomationDetailsApi } from "../api/automationDetails";

export const useAutomationDetails = ({ requestParams, useGlobalSearch, ...rest }) => {
  const data = useSimpleDataList({
    selector: paginatedAutomationDetailsSelector,
    resetAction: paginatedAutomationDetailsActions.resetList,
    getAction: getAutomationDetailsApi(requestParams.id), 
    itemDeleteText: "Are you sure you want to delete this?", // change this text message 
    itemsDeleteText: (selectedIds) =>
      `Are you sure you want to delete ${selectedIds.length}?`, // change this text message
    requestParams,
    actions: paginatedAutomationDetailsActions,
    ...rest,
  });

  return data
};

